module.exports = __webpack_public_path__ + "img/NL262.c27bb82b.png";